import { Map } from 'immutable';
import { combineActions, createAction, handleActions } from 'redux-actions';

export const initialState = Map({
  id: null,
  isAllLoading: false,
});

// const
export const CHECKOUT = 'purchase/CHECKOUT';
export const CLEAR_PURCHASE = 'purchase/CLEAR_PURCHASE';
export const CHECKOUT_OVERPAY = 'purchase/CHECKOUT_OVERPAY';
export const CHECKOUT_CREDIT_CARD = 'purchase/CHECKOUT_CREDIT_CARD';
export const COMPLETE_OVERPAY = 'purchase/COMPLETE_OVERPAY';
// purchase all
export const CONFIRMATION_ALL = 'purchase_all/CONFIRMATION';
export const COMPLETE_ALL_OVERPAY = 'purchase_all/COMPLETE_OVERPAY';

// actions
export const checkout = createAction(CHECKOUT);
export const clearPurchase = createAction(CLEAR_PURCHASE);
export const completeOverpayPayment = createAction(COMPLETE_OVERPAY);
export const checkoutOverpay = createAction(CHECKOUT_OVERPAY);
export const checkoutCreditCard = createAction(CHECKOUT_CREDIT_CARD);

// actions for purchase all
export const confirmationAll = createAction(CONFIRMATION_ALL);
export const completeAllOverpay = createAction(COMPLETE_ALL_OVERPAY);

// reducer
const purchaseReducer = handleActions(
  {
    [combineActions(
      CHECKOUT,
      COMPLETE_OVERPAY,
      CHECKOUT_OVERPAY,
      CHECKOUT_CREDIT_CARD,
    )]: (state, { payload }) => state.set('id', payload.id),
    [combineActions(CONFIRMATION_ALL, COMPLETE_ALL_OVERPAY)]: (state) =>
      state.set('isAllLoading', true),

    [CLEAR_PURCHASE]: () => initialState,
  },

  initialState,
);

export default purchaseReducer;
